import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15 17C13.0109 17 11.1032 16.2098 9.6967 14.8033C8.29018 13.3968 7.5 11.4891 7.5 9.5C7.5 7.51088 8.29018 5.60322 9.6967 4.1967C11.1032 2.79018 13.0109 2 15 2C16.9891 2 18.8968 2.79018 20.3033 4.1967C21.7098 5.60322 22.5 7.51088 22.5 9.5C22.5 11.4891 21.7098 13.3968 20.3033 14.8033C18.8968 16.2098 16.9891 17 15 17ZM2 2H6V22H2V2Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Patreon"
);
